/* eslint-disable camelcase -- Allow */
import { Inter, Geist_Mono } from 'next/font/google';
import { cn } from '@spellix/theme';

const inter = Inter({
  subsets: ['latin'],
  variable: '--font-sans',
});

const geistMono = Geist_Mono({
  subsets: ['latin'],
  variable: '--font-mono',
});

export const fonts = cn(inter.variable, geistMono.variable, 'touch-manipulation font-sans antialiased bg-background');
